import { parse } from 'node:path'

import { slugify } from '@scalar-org/helpers/url'
import { randomSlug } from '@scalar-org/random-slug'

/**
 * Generate URL slugs from a page name or path
 *
 * Generates a random slug if neither are provided
 */
export function createUrlSlug({
  name,
  path,
}: {
  name?: string
  path?: string
}) {
  if (name) return `/${slugify(name)}`

  if (path) return `/${slugify(parse(path).name)}`

  return `/${slugify(randomSlug({ words: 2 }))}`
}
